/** @format */

export interface ParentCatGroup {
  parentCategory: string;
}
